import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ar from './locales/ar.json';
import en from './locales/en.json';
import additionsAr from './additions.ar.json';
import additionsEn from './additions.en.json';
import type { Language } from '../lib/preferences';

/**
 * `locales/en.json` and `locales/ar.json` are the prototype's `T` map ported
 * verbatim — 383 keys, complete in both languages, with their original key names
 * (`complaints` for the Support module, and so on). Keeping them untouched means
 * the port stays diffable against the source and no string goes missing in a
 * rename.
 *
 * Strings this build introduces go in `additions.*.json` instead, so the two
 * remain distinguishable.
 */
export function initI18n(language: Language): typeof i18n {
  void i18n.use(initReactI18next).init({
    resources: {
      en: { translation: { ...en, ...additionsEn } },
      ar: { translation: { ...ar, ...additionsAr } },
    },
    lng: language,
    fallbackLng: 'en',
    interpolation: {
      // React escapes on render; escaping again mangles Arabic punctuation.
      escapeValue: false,
    },
    returnNull: false,
  });

  return i18n;
}

export { i18n };
